fx.ns("models", class FacialCluster extends fx.Model {

	constructor(data)
	{
		super(data);
    }
    
	get storable()
	{
		return false;
	}
});
